var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{attrs:{"width":"148px"}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.activeRouter,"router":"","background-color":"#f8f8f8","unique-opened":true,"text-color":"#161616","active-text-color":"#000"}},_vm._l((_vm.menuList),function(item,i){return _c('siderbar-item',{key:i,attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }